import React, { useEffect, useRef, useState } from 'react';
import createBonusUI from '@voogo/bonus-ui';
import '@voogo/bonus-ui/style.css';
import api from '../services/api';
const { QualificationOverview } = createBonusUI(React);
export default function BonusOverview({ allowReset = true, qualificationOnly = false }) {
  const [data,setData]=useState(null),[error,setError]=useState(false),[reload,setReload]=useState(0);
  const [reset,setReset]=useState(null),[busy,setBusy]=useState(false),[resetError,setResetError]=useState('');
  const payload=useRef(null),inFlight=useRef(false);
  useEffect(()=>{let active=true;setError(false);api.get('/admin/bonus-qualification/overview').then(r=>{if(active)setData(r.data);}).catch(()=>{if(active){setData(null);setError(true);}});return()=>{active=false;};},[reload]);
  useEffect(()=>{const refresh=()=>setReload(n=>n+1);window.addEventListener('focus',refresh);return()=>window.removeEventListener('focus',refresh);},[]);
  const openReset=(row,metric)=>{
    if(inFlight.current)return;
    payload.current=null;setResetError('');
    setReset({ row,metric,reason:'',request_id:window.crypto.randomUUID(),expected_reset_revision:Number(row.performance[metric].reset_id)||0 });
  };
  const submit=async()=>{
    if(inFlight.current || !reset || !reset.reason.trim())return;
    inFlight.current=true;
    if(!payload.current)payload.current={ metric:reset.metric,reason:reset.reason.trim(),request_id:reset.request_id,expected_reset_revision:reset.expected_reset_revision };
    setBusy(true);setResetError('');
    try {
      await api.post(`/admin/drivers/${encodeURIComponent(reset.row.driver_id)}/performance-reset`,payload.current);
      payload.current=null;setReset(null);setReload(n=>n+1);
    } catch(e) {
      setResetError(e.response?.status===409?'Inzwischen geändert – bitte schließen und neu laden.':e.response?.status===403?'Berechtigung fehlt.':'Ergebnis nicht bestätigt. Erneut versuchen verwendet denselben Auftrag.');
    } finally {inFlight.current=false;setBusy(false);}
  };
  if(error)return <p role="alert">Bonusübersicht konnte nicht geladen werden. <button onClick={()=>setReload(n=>n+1)}>Erneut laden</button></p>;
  return <>
    <button type="button" onClick={()=>setReload(n=>n+1)}>Leistung aktualisieren</button>
    {data?<QualificationOverview data={data} qualificationOnly={qualificationOnly} onReset={allowReset ? openReset : undefined}/>:<p>Bonusübersicht lädt…</p>}
    {reset&&<section aria-label="Leistungsbasis neu beginnen">
      <h4>{reset.metric==='acceptance'?'Annahme':'Storno'} für {reset.row.driver_name||reset.row.driver_id} neu beginnen</h4>
      <p>Nur diese Quote beginnt mit neuen Beobachtungen. Fahrten, Bewertungen, Wochenentscheidungen und Gutschriften bleiben erhalten.</p>
      <label>Grund <input value={reset.reason} maxLength={500} disabled={busy||!!payload.current} onChange={e=>setReset({...reset,reason:e.target.value})}/></label>
      {resetError&&<p role="alert">{resetError}</p>}
      <button type="button" disabled={busy||!reset.reason.trim()} onClick={submit}>{busy?'Wird gespeichert…':'Neu beginnen'}</button>
      <button type="button" disabled={busy} onClick={()=>{setReset(null);payload.current=null;setReload(n=>n+1);}}>Schließen</button>
    </section>}
  </>;
}
